import { getPublicProductBundles } from 'pricing-pages-lib/api/ProductBundlesApi';
import { fetchBundlesApiCompleted, fetchBundlesApiFailed, fetchBundlesApiStarted } from '../actions/PlanBuilderActions';
import { PLAN_BUILDER_INITIALIZATION_COMPLETE, PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED } from '../actions/constants/ActionTypes';
import { planBuilderProductConfigurationsSelector } from '../selectors/PlanBuilderSelectors';
import { productForSkuIdSelector } from '../selectors/ProductsSelectors';
import { productDataSelector } from '../selectors/SelectorUtils';

/**
 * Calls MonBE's bundles API after certain actions have updated productConfigurations
 * the bundles API is responsible for turning, e.g. 5 Starter hubs -> 1 Suite Starter bundle
 *
 * It's not necessary to call the bundles API on _every_ update to productConfigurations,
 * only on page load and when a new product gets added or a product level gets updated
 */
export const bundlesApiMiddleware = store => next => action => {
  if (action.type === PLAN_BUILDER_INITIALIZATION_COMPLETE || action.type === PLAN_BUILDER_PRODUCT_LEVEL_FOR_PRODUCT_LINE_UPDATED) {
    // Commit the previous action's payload to state so we can access
    // the updated productConfigurations below
    next(action);

    // Apply the loading state
    store.dispatch(fetchBundlesApiStarted());
    const state = store.getState();
    const productConfigurations = planBuilderProductConfigurationsSelector(state);
    const productData = productDataSelector(state);

    // currently the bundles API only accepts apiNames
    // in a future state, we will want to pass the entire productConfigurations
    const apiNames = productConfigurations.map(({
      skuId
    }) => {
      const product = productForSkuIdSelector(state, {
        skuId
      });
      return product && product.apiName;
    });
    getPublicProductBundles(apiNames).then(response => {
      const {
        products
      } = response;
      // the PlanBuilder reducer will merge the productConfigurations
      // in a future state, the bundles API should handle this merging
      store.dispatch(fetchBundlesApiCompleted({
        products,
        productData
      }));
    }).catch(() => {
      store.dispatch(fetchBundlesApiFailed());
    });
    return;
  }
  return next(action);
};